import {
  discoveryApiRef,
  fetchApiRef,
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { ClustersApiClient, clustersApiRef } from './api';
import { rootRouteRef } from './routes';
import tabs from './tabs';

const clustersApi = ApiBlueprint.make({
  name: 'clustersApi',
  params: defineParams =>
    defineParams({
      api: clustersApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new ClustersApiClient({ discoveryApi, fetchApi }),
    }),
});

export const catalogDevopsModuleClustersPlugin = createFrontendPlugin({
  pluginId: 'catalog-devops-module-clusters',
  routes: {
    root: rootRouteRef,
  },
  extensions: [clustersApi, ...tabs],
});
